import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/customerfile/${COMMON_QUERY_PARAMS.FILE_ID}/devicepassword`;

export interface SetDevicePasswordCommandPayload {
  fileId: string;
  devicePassword: string;
}

export const setDevicePasswordRequest = ({
  fileId,
  devicePassword,
}: SetDevicePasswordCommandPayload): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: { devicePassword },
  },
});

async function setDevicePasswordCommand({
  fileId,
  devicePassword,
}: SetDevicePasswordCommandPayload): Promise<BaseBackResponse> {
  try {
    return await executeQuery<BaseBackResponse>(
      setDevicePasswordRequest({ fileId, devicePassword }),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default setDevicePasswordCommand;
